import React from 'react';
import FirstPageIcon from '@material-ui/icons/FirstPage';
import LastPageIcon from '@material-ui/icons/LastPage';
import Button from '@material-ui/core/Button';

const flatButtonStyle = {
  minWidth: 16,
  backgroundColor: '#fff',
  color: '#000',
  borderRadius: '50%',
};

const calculateRange = (arg) => {
  const { total, current, display } = arg;
  let end = total;
  let start = 1;
  if (display < end) {
    // rounded to the nearest integer smaller
    let beforeNumber = Math.round(display / 2 - 0.5);
    const afterNumber = beforeNumber;
    if (display % 2 === 0) {
      beforeNumber -= 1;
    }

    if (current <= beforeNumber + 1) {
      end = display;
    } else if (current >= total - afterNumber) {
      start = total - display + 1;
    } else {
      start = current - beforeNumber;
      end = current + afterNumber;
    }
  }

  return { end, start };
};

const getStateFromProps = (props) => {
  let { total, current, display } = props;
  total = total > 0 ? total : 1;
  display = display > 0 ? display : 1;
  current = current < total ? current : total;
  display = display < total ? display : total;
  return { current, display, total };
};

const Page = React.memo(({ value, isActive, onClick, selectedClass }) => (
  <Button
    style={flatButtonStyle}
    className={isActive ? selectedClass : ''}
    onClick={onClick}
  >
    {value + 1}
  </Button>
));

const FirstPageLink = React.memo(({ onClick }) => (
  <Button style={flatButtonStyle} onClick={onClick}>
    <FirstPageIcon />
  </Button>
));

const LastPageLink = React.memo(({ onClick }) => (
  <Button style={flatButtonStyle} onClick={onClick}>
    <LastPageIcon />
  </Button>
));

class Pagination extends React.Component {
  constructor(props) {
    super(props);
    const tem = getStateFromProps(props);

    this.state = {
      ...tem,
      ...calculateRange(tem),
    };
  }

  /* componentWillReceiveProps(nextProps) {
    const tem = getStateFromProps(nextProps);
    this.setState({
      ...tem,
      ...calculateRange(tem),
    });
  } */

  static getDerivedStateFromProps(nextProps, prevState) {
    if (
      nextProps.current !== prevState.current ||
      nextProps.display !== prevState.display ||
      nextProps.total !== prevState.total
    ) {
      const tem = getStateFromProps(nextProps);
      return {
        ...tem,
        ...calculateRange(tem),
      };
    }
    return null;
  }

  setCurrent = (current) => {
    const tem = { ...this.state, current };
    this.props.onChange(current);
    this.setState({
      ...tem,
      ...calculateRange(tem),
    });
  };

  render() {
    const array = [];
    for (let i = this.state.start; i <= this.state.end; i += 1) {
      array.push(i - 1);
    }
    return (
      <div style={this.props.styleRoot}>
        <FirstPageLink
          onClick={() => this.setCurrent(0)}
          styleFirstPageLink={this.props.styleFirstPageLink}
        />
        {array.map((page, k) => (
          <Page
            key={k}
            value={page}
            isActive={this.state.current === page}
            onClick={() => this.setCurrent(page)}
            selectedClass={this.props.selectedClass}
          />
        ))}
        <LastPageLink
          onClick={() => this.setCurrent(this.state.total - 1)}
          styleLastPageLink={this.props.styleLastPageLink}
        />
      </div>
    );
  }
}

export default Pagination;
